import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { TestimonialVideo } from '../types';
import { CustomVideoPlayer, CustomVideoPlayerRef } from './custom-video-player';

interface TestimonialCardProps {
  video: TestimonialVideo;
  onPlay?: () => void;
  onPause?: () => void;
  isPlaying?: boolean;
}

export const TestimonialCard = forwardRef<CustomVideoPlayerRef, TestimonialCardProps>(
  ({ video, onPlay, onPause, isPlaying = false }, ref) => {
    const { t } = useTranslation();

    return (
      <div className="flex flex-col">
        <div
          className={clsx(
            'relative flex-shrink-0 w-[311px] h-[175px] rounded-[24px] overflow-hidden',
            'sm:w-[450px] sm:h-[320px]',
            'md:w-[550px] md:h-[360px]',
            'lg:w-[650px] lg:h-[380px]'
          )}
        >
          <CustomVideoPlayer
            ref={ref as any}
            videoUrl={video.videoUrl}
            thumbnailUrl={video.thumbnailUrl}
            onPlay={onPlay}
            onPause={onPause}
          />

          {/* Title overlay - only show on sm+ screens when paused */}
          {!isPlaying && (
            <div className={clsx(
              'absolute bottom-0 left-0 right-0 p-4 h-full pointer-events-none',
              'flex',
              'flex-col justify-end',
              'bg-gradient-to-t from-black to-black/10'
            )}>
              <p className="hidden sm:block text-white font-bold text-[22px] max-w-[85%]">{t(video.title)}</p>
            </div>
          )}
        </div>

        {/* Title below card - only show on mobile screens */}
        <div className="sm:hidden mt-3 px-1 w-[311px] overflow-hidden">
          <p className="text-text-primary font-bold text-[16px] leading-[22px]">{t(video.title)}</p>
        </div>
      </div>
    );
  }
);

TestimonialCard.displayName = 'TestimonialCard';
